import {
	ComplianceLevel,
	IS_GDPR_LIMITED,
	IS_HIPAA,
	IS_LIMITED,
	NO_RESTRICTIONS,
	REQUIRE_GDPR_MODAL,
} from '@/store/complianceLevel/types';

import { CALM_IS_HIPAA_USER, CALM_LIMITED_DATA_USE, DECLINE_GDPR_COOKIES_KEY } from '../privacyCookies';

export const determineComplianceLevel = ({
	requiresGdpr,
	isLimitedData,
	hasDeclinedGdprCookies,
	isHipaaUser,
}: {
	requiresGdpr?: boolean | null;
	isLimitedData?: boolean;
	hasDeclinedGdprCookies?: boolean;
	isHipaaUser?: boolean;
}): ComplianceLevel => {
	if (hasDeclinedGdprCookies === true) {
		return IS_GDPR_LIMITED;
	}
	if (requiresGdpr === true) {
		return REQUIRE_GDPR_MODAL;
	}
	if (isLimitedData === true) {
		return IS_LIMITED;
	}
	if (isHipaaUser) {
		return IS_HIPAA;
	}
	return NO_RESTRICTIONS;
};

// Single place both routers read the three compliance cookies from a flat
// cookie dict — pages-router builds that dict via nookies, app-router via
// next/headers `cookies()`, but the keys they extract must stay identical.
export const determineComplianceLevelFromCookies = (
	cookieValues: Record<string, string>,
	requiresGdpr: boolean | null,
): ComplianceLevel =>
	determineComplianceLevel({
		requiresGdpr,
		isLimitedData: Boolean(cookieValues[CALM_LIMITED_DATA_USE]),
		hasDeclinedGdprCookies: Boolean(cookieValues[DECLINE_GDPR_COOKIES_KEY]),
		isHipaaUser: Boolean(cookieValues[CALM_IS_HIPAA_USER]),
	});
